import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import Students from "./components/Students/index";
import FamilyMembers from "./components/FamilyMembers/index";
import TimetableConfiguration from "../TimetableConfiguration";
import Notification from "./components/Notification/index";
import Module from "./components/Module/index";
import Teachers from "./components/Teachers/index";
import Journal from "./components/Journal/index";
import AssessmentCategories from "./components/AssessmentCategoriesWrapper/index";
export default store => ({
  path: "settingsV2",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "settingsV2" */ "./components"),
        import(
          /* webpackChunkName: "settingsV2" */ "../ManageFamily/modules/ManageFamilyModule"
        ),
        import(
          /* webpackChunkName: "settingsV2" */ "../TimetableConfiguration/modules/TimetableConfigurationModule"
        ),
        import(
          /* webpackChunkName: "settingsV2" */ "Administrator/modules/CommonModule"
        ),
        import(
          /* webpackChunkName: "settingsV2" */ "CourseSetup/components/CreateCourse/containers/CreateCourseModule"
        ),
        import(
          /* webpackChunkName: "settingsV2" */ "CourseSetup/components/EditCourse/containers/CourseDetailsModule"
        ),
        import(
          /* webpackChunkName: "settingsV2" */ "CourseSetup/components/EditCourse/containers/CourseDetailsModule"
        ),
        import(
          /* webpackChunkName: "settingsV2" */ "CourseSetup/modules/Module"
        ),
        import(/* webpackChunkName: "settingsV2" */ "./modules/SettingsModule"),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
          importedModule6,
          importedModule7,
          importedModule8,
        ]) => {
          const component = importedModule0.default;
          const manageFamilyReducer = importedModule1.default;
          const timetableConfigurationReducer = importedModule2.default;
          const adminCommonReducer = importedModule3.default;
          const CreateCourseModule = importedModule4;
          const courseDetailsModule = importedModule5;
          const courseDetailsModuleReducer = importedModule6.default;
          const classSetupReducer = importedModule7.default;
          const classSetupReducerV2 = importedModule8.default;
          injectReducer(store, {
            key: "manageFamily",
            reducer: manageFamilyReducer,
          });
          injectReducer(store, {
            key: "timetableConfiguration",
            reducer: timetableConfigurationReducer,
          });
          injectReducer(store, {
            key: "adminCommon",
            reducer: adminCommonReducer,
          });
          injectReducer(store, {
            key: CreateCourseModule.NAME,
            reducer: CreateCourseModule.default,
          });
          injectReducer(store, {
            key: courseDetailsModule.NAME,
            reducer: courseDetailsModule.default,
          });
          injectReducer(store, {
            key: "classDetails",
            reducer: courseDetailsModuleReducer,
          });
          injectReducer(store, {
            key: "classSetup",
            reducer: classSetupReducer,
          });
          injectReducer(store, {
            key: "classSettingsV2",
            reducer: classSetupReducerV2,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Students(store),
    FamilyMembers(store),
    Notification(store),
    TimetableConfiguration(store),
    Module(store),
    Teachers(store),
    Journal(store),
    AssessmentCategories(store),
  ],
});
